import { mergeClasses, Popover, PopoverSurface, } from '@fluentui/react-components';
import { useNovaEventing } from '@nova/react';
import { AppBarEvents } from '@office-start/appbar-events';
import React, { useEffect } from 'react';
import { Flyout } from './Flyout';
import { useFlyoutButtonStyles } from './FlyoutButton.styles';
import { FlyoutContextProvider } from './FlyoutContext';
var popoverOffset = { crossAxis: 0, mainAxis: -2 };
/**
 * Lazy loaded flyout control.
 */
export var LazyFlyout = function (props) {
    var targetRef = props.targetRef, flyoutOpen = props.flyoutOpen, handleOpenChange = props.handleOpenChange, ariaLabel = props.ariaLabel, flyoutSize = props.flyoutSize, footerLinks = props.footerLinks;
    var styles = useFlyoutButtonStyles();
    var popoverStyles = mergeClasses(styles.flyoutContainer, (footerLinks == null || (footerLinks === null || footerLinks === void 0 ? void 0 : footerLinks.length) === 0) &&
        styles.flyoutContainerNoFooter, flyoutSize === 'Small' && styles.flyoutContainerSmall);
    var novaEventing = useNovaEventing();
    useEffect(function () {
        if (flyoutOpen) {
            novaEventing.generateEvent({
                event: AppBarEvents.flyoutRendered(),
            });
        }
    }, [novaEventing, flyoutOpen]);
    return (React.createElement(Popover, { open: flyoutOpen, onOpenChange: handleOpenChange, positioning: {
            position: 'after',
            overflowBoundary: 'window',
            offset: popoverOffset,
            target: targetRef,
        }, withArrow: false, trapFocus: true, legacyTrapFocus: true },
        React.createElement(PopoverSurface, { className: popoverStyles, "aria-label": ariaLabel },
            React.createElement(FlyoutContextProvider, { launchOptions: props },
                React.createElement(Flyout, null)))));
};
export default LazyFlyout;
//# sourceMappingURL=LazyFlyout.js.map